import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { Avatar } from 'primereact/avatar';

const AppTopbar = (props: any) => {
    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <>
            <div className="layout-topbar">
                <div className="layout-topbar-left">{/* <img src="/assets/images/Logo-white.png" className="img-fluid" width={80} alt="login-logo" /> */}</div>

                <div className="layout-topbar-right flex align-items-center">
                    <ul className="layout-topbar-right-items">
                        <li id="profile" className={classNames('profile-item', { 'active-topmenuitem': props.topbarMenuActive })}>
                            <button className="p-link " onClick={props.onTopbarItemClick}>
                                <>
                                    <Avatar image={'/assets/images/avatar.png'} style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" className="top-p-avatar img-fluid" />
                                    <span style={{ color: '#fff' }} className="ml-2">
                                        {localStorage.getItem('full_name')}
                                    </span>
                                </>
                            </button>

                            <ul className="fadeInDown">
                                <>
                                    <li role="menuitem">
                                        <button className="p-link" onClick={() => navigate('/change-password')}>
                                            <i className="pi pi-lock"></i>
                                            <span>Change Password</span>
                                        </button>
                                    </li>
                                    <li role="menuitem">
                                        <button className="p-link" onClick={logout}>
                                            <i className="pi pi-power-off"></i>
                                            <span>Logout</span>
                                        </button>
                                    </li>
                                </>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default AppTopbar;
